// add required class to main labels of required form elements
const $required = document.querySelectorAll('[required]');
$required.forEach(($el) => {
    const { id } = $el;
    const $label = document.querySelector(`label[for="${id}"]`);
    if ($label) {
        $label.classList.add('required', '-required');
    }
});
